<template>
  <layout-component>
    <div class="container">
      <div class="row form-wrapper pb-4 pb-md-2">
        <div class="col-md-7 col-lg-8 form form-login">
          <h1 class="br-title left-bullet" v-html="$t('w.register.title-banner')"></h1>
          <p class="br-title p-intro mr-lg-5 pr-lg-5" v-html="$t('w.register.subtitle-01')"></p>
          <div class="row">
            <div class="col-lg-9">
              <b-alert :show="has_error && !success" fade variant="danger">
                <template v-if="error == 'registration_validation_error'">
                  <h4><i class="fal fa-times"></i> {{'w.register.error-title-01'|t}}</h4>
                  <p>{{'w.register.error-text-01'|t}}</p>
                </template>
                <template v-else>
                  <h4><i class="fal fa-times"></i> {{'w.register.error-title-02'|t}}</h4>
                  <p>{{'w.register.error-text-02'|t}}</p>
                </template>
              </b-alert>

              <form autocomplete="off" @submit.prevent="register" v-if="!success" method="post">
                <h3 v-html="$t('w.register.title-01')"></h3>
                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.name }">
                        <label for="register-name">{{'w.register.label-firstname'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-name" class="form-control" placeholder="Peter" v-model="name">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.name" v-html="errors.name.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.surname }">
                        <label for="register-surname">{{'w.register.label-lastname'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-surname" class="form-control" placeholder="Parker" v-model="surname">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.surname" v-html="errors.surname.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.email }">
                        <label for="register-email">{{'w.register.label-email'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="email" id="register-email" class="form-control" placeholder="user@example.com" v-model="email">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.email" v-html="errors.email.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.email }">
                        <label for="register-email_confirmation">{{'w.register.label-email-confirmation'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="email" id="register-email_confirmation" class="form-control" placeholder="user@example.com" v-model="email_confirmation">
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.password }">
                        <label for="register-password">{{'w.register.label-password'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="password" id="register-password" class="form-control" v-model="password">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.password" v-html="errors.password.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.password }">
                        <label for="register-password_confirmation">{{'w.register.label-password-confirmation'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="password" id="register-password_confirmation" class="form-control" v-model="password_confirmation">
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.phone }">
                        <label for="register-phone">{{'w.register.label-phone-number'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-phone" class="form-control" placeholder="+352 123456789" v-model="phone">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.phone" v-html="errors.phone.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <h3 v-html="$t('w.register.title-02')"></h3>
                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.company }">
                        <label for="register-company">{{'w.register.label-company-name'|t}} <em>{{'w.register.label-optional'|t}}</em></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-company" class="form-control" placeholder="Daily Bugle" v-model="company">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.company" v-html="errors.company.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.vat }">
                        <label for="register-vat">{{'w.register.label-vat-number'|t}} <em v-if="!company">{{'w.register.label-optional'|t}}</em></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-vat" class="form-control" placeholder="LU12345678" v-model="vat">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.vat" v-html="errors.vat.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <template v-if="!isApp">
                <h3 v-html="$t('w.register.title-03')"></h3>
                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.address }">
                        <label for="register-address">{{'w.register.label-address'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-address" class="form-control" placeholder="115c, rue Emile Mark" v-model="address">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.address" v-html="errors.address.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.address2 }">
                        <label for="register-address2">{{'w.register.label-address-supplement'|t}} <em>{{'w.register.label-optional'|t}}</em></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-address2" class="form-control" v-model="address2">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.address2" v-html="errors.address2.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.postcode }">
                        <label for="register-postcode">{{'w.register.label-postcode'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-postcode" class="form-control" placeholder="4620" v-model="postcode">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.postcode" v-html="errors.postcode.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.city }">
                        <label for="register-city">{{'w.register.label-city'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-city" class="form-control" placeholder="Differdange" v-model="city">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.city" v-html="errors.city.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.countrycode }">
                        <label for="register-countrycode">{{'w.register.label-country'|t}} <span class="required">*</span></label>
                        <div class="select-wrapper">
                          <b-form-select id="register-countrycode" v-model="countrycode" :options="countrycodes" :plain="true" />
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.countrycode" v-html="errors.countrycode.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                </template>

                  <div class="row">
                  <div class="col-md-12 pb-1 pt-1 pt-md-0 pb-md-0">
                    <div class="form-group checkbox-wrapper" :class="{ 'has-error': has_error && errors.agreerules }">
                      <b-form-checkbox id="agreerules" name="agreerules" value="agreerules" unchecked-value="agreerules">
                        {{'w.register.agree-rules'|t}} <span class="required">*</span>
                      </b-form-checkbox>
                      <small class="form-text text-danger" v-if="has_error && errors.agreerules" v-html="errors.agreerules.join('<br />')"></small>
                    </div>

                    <div class="form-group checkbox-wrapper" :class="{ 'has-error': has_error && errors.agreeprivacy }">
                      <b-form-checkbox id="agreeprivacy" name="agreeprivacy" value="agreeprivacy" unchecked-value="agreeprivacy" class="cart-agreerules">
                        {{'w.register.agree-privacy'|t}} <div v-html="$t('w.register.agree-privacy-links')"></div>
                        <span class="required">*</span>
                      </b-form-checkbox>
                      <small class="form-text text-danger" v-if="has_error && errors.agreeprivacy" v-html="errors.agreeprivacy.join('<br />')"></small>
                    </div>

                    <div class="form-group checkbox-wrapper" :class="{ 'has-error': has_error && errors.agreedata }">
                      <b-form-checkbox id="agreedata" name="agreedata" value="agreedata" unchecked-value="agreedata">
                        {{'w.register.agree-data'|t}}
                      </b-form-checkbox>
                      <small class="form-text text-danger" v-if="has_error && errors.agreedata" v-html="errors.agreedata.join('<br />')"></small>
                    </div>
                  </div>
                </div>


                <button type="submit" class="btn btn-primary btn-submit"><span>{{ 'w.register.submit-btn' | t }}</span></button>
              </form>

            </div>
          </div>
        </div>

        <div class="ml-auto col-md-4 col-lg-3 sidebar-right pt-md-4 pt-3">
          <h3 class="left-bullet" v-html="$t('w.register.sidebar-title-01')"></h3>
          <p class="br-title" v-html="$t('w.register.sidebar-text-01')"></p>
          <router-link class="btn" to="/login"><span>{{ 'w.register.btn-sidebar' | t }}</span></router-link>
        </div>
      </div>

    </div>
	</layout-component>
</template>
<script>
  export default {
    data() {
      return {
        name: '',
        surname: '',
        email: '',
        email_confirmation: '',
        password: '',
        password_confirmation: '',
        phone: '',
        company: '',
        vat: '',
        address: '',
        address2: '',
        postcode: '',
        city: '',
        countrycode: 'LU',
        countrycodes: [],
        has_error: false,
        error: '',
        errors: {},
        success: false,
        isApp: false,
      }
    },
    mounted() {
      this.countrycodes = this.$store.countryCodes;
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
        Vue.axios.get('/auth/user').then( ({data}) => {
            if(data.data){
                this.$router.push('book');
            }
        })

        this.isApp = window.isApp;
    },

    methods: {
      register() {
        var app = this
        this.$auth.register({
          data: {
            name: this.name,
            surname: this.surname,
            email: this.email,
            email_confirmation: this.email_confirmation,
            password: this.password,
            password_confirmation: this.password_confirmation,
            phone: this.phone,
            company: this.company,
            vat: this.vat,
            address: this.address,
            address2: this.address2,
            postcode: this.postcode,
            city: this.city,
            countrycode: this.countrycode,
            isApp: this.isApp,
            locale: this.$i18n.locale,
          },
          autoLogin: false,
          rememberMe: false,
          success: function () {
            app.success = true
            // handle redirection
            this.$router.push('register-success')
          },
          error: function (res) {
            app.has_error = true
            app.error = res.response.data.error
            app.errors = res.response.data.errors || {}
            setTimeout(function(){
              animateScrollTo(document.querySelector('.' +
                  ''), {
                offset: -200,
                passive: true
              });
          }, 50);
          }
        })
      }
    }
  }
</script>
